import PhoneManagement from './PhoneManagement';

export default PhoneManagement;
